/* eslint-disable no-unused-vars */
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Row, Col } from 'react-bootstrap';
import { options } from '../../utils/tableUtils';

export default function Table({
  title,
  data,
  profonditaStorica,
  button,
  fields,
  pagination,
  onTableChange,
  campoSort,
  keyField,
  selectRow,
  cellEdit,
}) {
  return (

    <Row className="m-1 justify-content-around">

      {title || button ? (
        <Col>
          <p className="fw-bold fs-3">
            {title}
            {' '}
            {button}
          </p>
        </Col>
      ) : null}
      {profonditaStorica ? (
        <Col className="mb-1 col-md-3 ms-auto">
          {profonditaStorica}
        </Col>
      ) : null}

      <BootstrapTable
        remote
        // defaultSorted={[{
        //   dataField: campoSort || '',
        //   order: 'desc',
        // }]}
        bordered={false}
        columns={fields}
        keyField={keyField}
        wrapperClasses="table-responsive-sm"
        data={data}
        pagination={pagination && paginationFactory({
          ...options,
          page: pagination.page,
          sizePerPage: pagination.sizePerPage,
          totalSize: pagination.totalSize,
        })}
        onTableChange={onTableChange}
        selectRow={selectRow}
        cellEdit={cellEdit}
        striped={false}
        rowStyle={{ borderBottomWidth: '2px' }}
      />
    </Row>
  );
}
